var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "file-upload-single-item" }, [
    _c("div", { staticClass: "file-upload-single-item-name" }, [
      _vm._v("\n    " + _vm._s(_vm.file.name) + "\n  "),
    ]),
    _c(
      "button",
      {
        staticClass: "btn-text btn-text--primary",
        attrs: { type: "button" },
        on: {
          click: function ($event) {
            return _vm.$emit("remove")
          },
        },
      },
      [_vm._v("\n    " + _vm._s(_vm.$t("fileUpload.delete")) + "\n  ")]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }